// Local Storage Key
export enum LSKey {
    Service = 'service',
    Employee = 'employee',
    Client = 'client',
    PetInfo = 'petInfo',
    Comments = 'comments',
    Datetime = 'datetime',
    RescheduleGuid = 'rescheduleGuid',
    DateTimeOfDayList = 'dateTimeOfDayList',
}
